module.exports = "/images/vendor/flag-icon-css/flags/4x3/wf.svg?e3ac728c6286182ecee6047ba2d84627";